import apolloClient from '../../utils/apollo-client';
import { getApplication as query } from '../graphql/application';

export default async function () {
  const response = await apolloClient().then((client) =>
    client.query({
      query
    })
  );
  return response.data.getActiveApplication;
}
